import { Injectable } from '@angular/core';
import { combineLatest, fromEvent, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  private static media(query: string): Observable<boolean> {
    // https://webdevetc.com/blog/matchmedia-events-for-window-resizes/
    const mediaQuery = window.matchMedia(query);
    return fromEvent<MediaQueryList>(mediaQuery, 'change').pipe(
      startWith(mediaQuery),
      map((list: MediaQueryList) => list.matches)
    );
  }

  public getPageSize(): Observable<'xs' | 'sm' | 'md' | 'lg' | 'xl'> {
    // https://github.com/angular/flex-layout/wiki/Responsive-API
    const xs$ = MediaService.media('screen and (max-width: 599px)');
    const sm$ = MediaService.media('screen and (min-width: 600px) and (max-width: 959px)');
    const md$ = MediaService.media('screen and (min-width: 960px) and (max-width: 1279px)');
    const lg$ = MediaService.media('screen and (min-width: 1280px) and (max-width: 1919px)');
    const xl$ = MediaService.media('screen and (min-width: 1920px)');

    return combineLatest([xs$, sm$, md$, lg$, xl$]).pipe(
      map(([xs, sm, md, lg, xl]) => {
        if (xs) {
          return 'xs';
        }
        if (sm) {
          return 'sm';
        }
        if (md) {
          return 'md';
        }
        if (lg) {
          return 'lg';
        }
        if (xl) {
          return 'xl';
        }
        return 'md';
      })
    );
  }
}
